'use strict'

export default class LazyLoader {
  constructor (selector) {
    this.lazyImages = document.querySelectorAll(selector)
    this.lazyLoad = this.lazyLoad.bind(this)
    this.isElementInViewport = this.isElementInViewport.bind(this)

    window.addEventListener('DOMContentLoaded', () => {
      this.init()
    })
  }

  init () {
    this.lazyLoad()
    window.addEventListener('scroll', this.lazyLoad)
    window.addEventListener('resize', this.lazyLoad)
  }

  lazyLoad () {
    this.lazyImages.forEach((img) => {
      if (this.isElementInViewport(img) && !img.src) {
        img.src = img.getAttribute('data-src')
      }
    })
  }

  isElementInViewport (el) {
    const rect = el.getBoundingClientRect()
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }
}
